import { StrictMode } from 'react';
import { createRoot, type Container } from 'react-dom/client';
import { theme } from './theme/theme.ts';
import { ThemeProvider } from 'styled-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { RouteProvider } from './components/root/RouteProvider.tsx';
import './styles/style.scss';
import { PageProvider } from './components/root/PageProvider.tsx';
import 'react-loading-skeleton/dist/skeleton.css';

const queryClient = new QueryClient();

createRoot(document.getElementById('root') as Container).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<PageProvider>
				<BrowserRouter>
					<QueryClientProvider client={queryClient}>
						<RouteProvider />
					</QueryClientProvider>
				</BrowserRouter>
			</PageProvider>
		</ThemeProvider>
	</StrictMode>,
);
